import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog"
import type { Route, Stop } from "@/types/collections"

interface CancelStopDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  target: { stop: Stop; route: Route } | null
  onConfirm: () => void
}

/** The removal is staged until the route is saved. */
export default function CancelStopDialog({
  open,
  onOpenChange,
  target,
  onConfirm,
}: CancelStopDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Cancel Stop</AlertDialogTitle>
          <AlertDialogDescription>
            Are you sure you want to cancel the stop at{" "}
            <span className="font-semibold">{target?.stop.name}</span>? It will be removed from
            route {target?.route.code} when you save your changes — until then you can still
            discard it.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className="bg-palette-jungleGreen100 text-palette-jungleGreen700 hover:bg-palette-jungleGreen200">
            Keep Stop
          </AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} variant="destructive">
            Cancel Stop
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
